import React from 'react';

const STYLES = {
  BUY:       'bg-green-600 text-white',
  WEAK_BUY:  'bg-green-400/80 text-green-950',
  HOLD:      'bg-gray-500 text-white',
  WEAK_SELL: 'bg-red-400/80 text-red-950',
  SELL:      'bg-red-600 text-white',
};

const LABELS = {
  BUY: 'BUY',
  WEAK_BUY: 'LEAN BUY',
  HOLD: 'NEUTRAL',
  WEAK_SELL: 'LEAN SELL',
  SELL: 'SELL',
};

const SignalBadge = ({ signal, size = 'sm' }) => {
  const cls = STYLES[signal] || STYLES.HOLD;
  const sizeCls = size === 'lg'
    ? 'px-3 py-1.5 text-sm font-semibold tracking-wider'
    : 'px-2 py-0.5 text-[10px] font-semibold tracking-wider';
  return (
    <span className={`inline-block rounded ${sizeCls} ${cls}`}>
      {LABELS[signal] || signal}
    </span>
  );
};

export default SignalBadge;
